import {
	Breakpoints,
	Container,
	ContainerGutter,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { HuchaDisclaimer2Plus15Text, HuchaDisclaimer2StandardText } from '../../disclaimers/hucha-disclaimers';
import { handleScrollToDisclaimer } from '../../../../../../helpers/disclaimers/disclaimers-utils';
import { useDisclaimers } from '../../../../../../context/disclaimers-context';
import { COLOR_TOKEN, huchaLinesColor } from '../../../../../../helpers/color-tokens';
import { HuchaValues } from '../../../models/hucha-values';
import { Super100SymbolResponsiveText, Super100ResponsiveText } from '../../ui/money-font-styles';
import { RenovadoresLabel } from '../../ui/renovadores-label';

const MainContainer = styled(Container)`
	overflow: visible;
	padding: 0px;

	/* Mobile */
	@media (max-width: 959px) {
		padding-top: 40px;
	}

	/* Desktop */
	@media (min-width: 960px) {
		padding-top: 18px;
		padding-left: var(--size-dynamic0100);
	}
`;

const StyledC3Wrapper = styled.div`
	border: 2px solid ${COLOR_TOKEN.focus.main};
	border-radius: 16px;
	position: relative;
	align-content: center;
	padding-left: var(--size-dynamic0130);
	padding-right: var(--size-dynamic0130);

	/* Mobile */
	@media (max-width: 959px) {
		height: 280px;
	}

	/* Tablet */
	@media (min-width: 960px) {
		height: 270px;
	}

	/* Desktop */
	@media (min-width: 1600px) {
		height: 214px;
	}
`;

const StyledTextWrapper = styled(Container)`
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	padding-top: var(--size-dynamic0050);
	padding-bottom: var(--size-dynamic0050);
	padding-left: 4px;
	padding-right: 4px;
	width: 100%;

	/* Aseguramos que el wrapper se centre horizontalmente cuando el padre hace wrap='always' */
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 559px) {
		max-width: 227px;
	}

	@media (min-width: 560px) {
		max-width: 292px;
	}

	@media (min-width: 1600px) {
		/* Cuando wrap='never' podríamos resetear los valores con 'unset' para que dependa del padre */
		margin-left: unset;
		margin-right: unset;
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;

	/* Mobile */
	@media (max-width: 559px) {
		margin-top: 0px;
	}
`;

const CardRenovadoresLabel = styled(RenovadoresLabel)`
	@media (min-width: 1600px) {
		left: 27%;
	}
`;

export const RenovadoresBonusCardC3: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }) => {
	const { findBadge } = useDisclaimers();
	const HuchaDisclaimer2Text =
		huchaValues?.renovadorTier === 'plus15' ? HuchaDisclaimer2Plus15Text : HuchaDisclaimer2StandardText;
	const badge = findBadge(HuchaDisclaimer2Text);

	return (
		<MainContainer stretchContent data-testid="c3-container">
			<StyledC3Wrapper>
				<CardRenovadoresLabel />
				<Container
					gutter={ContainerGutter.dynamic0100}
					verticalAlign="center"
					stretchContent
					horizontalAlign="center"
					data-testid="c3-inner-container"
					wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b1600]: 'never' }}
				>
					<Container wrap="never" horizontalAlign="center">
						<Container wrap="never" verticalAlign="flex-end">
							<Super100ResponsiveText color={TokenTextColor.inverted}>+1.000</Super100ResponsiveText>
							<Super100SymbolResponsiveText color={TokenTextColor.inverted}>{'€'}</Super100SymbolResponsiveText>
						</Container>
						{badge && (
							<StyledReferenceBadge
								variant="large"
								onClick={() => {
									if (badge) handleScrollToDisclaimer(badge);
								}}
							>
								{badge.replace(/\.$/, '')}
							</StyledReferenceBadge>
						)}
					</Container>

					<StyledTextWrapper stretchContent verticalAlign="center" horizontalAlign="center">
						<Text
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.inverted}
							textAlign={TextAlignment.center}
						>
							{'La Excusa Oficial Volkswagen para renovar tu coche este año'}
						</Text>
					</StyledTextWrapper>
				</Container>
			</StyledC3Wrapper>
		</MainContainer>
	);
};
